"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDeferred = function () {
    var deferred = {
        resolve: function () { return undefined; },
        reject: function () { return undefined; },
        promise: new Promise(function () { return undefined; })
    };
    var promise = new Promise(function (resolve, reject) {
        deferred.resolve = resolve;
        deferred.reject = reject;
    });
    deferred.promise = promise;
    return deferred;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvbWlzZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdXRpbHMvcHJvbWlzZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFTYSxRQUFBLGNBQWMsR0FBRztJQUM1QixJQUFNLFFBQVEsR0FBYztRQUMxQixPQUFPLEVBQUUsY0FBTSxPQUFBLFNBQVMsRUFBVCxDQUFTO1FBQ3hCLE1BQU0sRUFBRSxjQUFNLE9BQUEsU0FBUyxFQUFULENBQVM7UUFDdkIsT0FBTyxFQUFFLElBQUksT0FBTyxDQUFDLGNBQU0sT0FBQSxTQUFTLEVBQVQsQ0FBUyxDQUFDO0tBQ3RDLENBQUE7SUFFRCxJQUFNLE9BQU8sR0FBRyxJQUFJLE9BQU8sQ0FBQyxVQUFDLE9BQW1CLEVBQUUsTUFBa0I7UUFDbEUsUUFBUSxDQUFDLE9BQU8sR0FBRyxPQUFPLENBQUE7UUFDMUIsUUFBUSxDQUFDLE1BQU0sR0FBRyxNQUFNLENBQUE7SUFDMUIsQ0FBQyxDQUFDLENBQUE7SUFFRixRQUFRLENBQUMsT0FBTyxHQUFHLE9BQU8sQ0FBQTtJQUUxQixPQUFPLFFBQVEsQ0FBQTtBQUNqQixDQUFDLENBQUEifQ==